function scrollAnimate() {


    //gsap.registerPlugin(SplitText);

    document.querySelectorAll(".scroll-animate").forEach(container => {

        let masterTl = new gsap.timeline({paused:true});

        if (hasClass(container, 'scroll-animate-claim')) {  // && !isMobile

            let body = document.querySelector('body');

            masterTl.to(container, {y: '110%',duration:0.6,ease: 'sine.in'});
    
             const configScrollAnimation = {
              // markers: true,
               trigger: body,
               //scrub:1,
               start: '20vh',
               end:  document.body.scrollHeight - window.innerHeight - 300,
               onEnter: () => {

                    //console.log('onEnter');
                    masterTl.play();
                }, 
                onLeave: () => {
                    //console.log('onLeave');
                    masterTl.reverse();
                
                },
                onLeaveBack: () => {

                    //console.log('onLeaveBack');
                    masterTl.reverse();

                    
                },
                onEnterBack: () => {

                    //console.log('onEnterBack');
                    masterTl.play();
                },
                
             }
    
            ScrollTrigger.create(configScrollAnimation);
    
        }

        if (hasClass(container, 'move-in-left') && !isMobile) { 

            masterTl.from(container, {x: '-5rem' ,alpha:0, duration:1,ease: 'power2.out'});

    
             const configScrollAnimation = {
              // pin:true,
               trigger: container,
               animation: masterTl,
               //scrub:1,
               start: 'top 85%',
               //end:  'top 55%',
               onEnter: ()=>{
                masterTl.play();
               }
             }
    
            ScrollTrigger.create(configScrollAnimation);
    
          
        }

        if (hasClass(container, 'move-in-bottom') && !isMobile) {


            masterTl.from(container, {y: '4rem', alpha: 0, duration: 0.8,  ease: 'power1.easeOut'});
    
             const configScrollAnimation = {
    
               trigger: container,
               start: 'top bottom',
               end:  'top 75%',
               onEnter: ()=> {
                masterTl.play();
               }
    
             }
            ScrollTrigger.create(configScrollAnimation);
    
        }

        if (hasClass(container, 'text-move-in-bottom') && !isMobile) {

            const split = new SplitText(container, {type: "lines", linesClass: "lines"});
    
            split.lines.forEach(line => {
              wrap(line, document.createElement('div'));
              line.style.display = 'inline-block';
            });
    
            masterTl.from(split.lines, {
              y:'100%',
              stagger:0.1,
              duration: 0.3,
              ease: 'power1.out'
            });
    
            const configScrollAnimation = {
              trigger: container,
               start: 'top 85%',
               end:  'top 100%',
               onEnter: ()=> {
                masterTl.play();
               }
    
             }
    
            ScrollTrigger.create(configScrollAnimation);
            
          
        }

        if (hasClass(container, 'move-in-bottom-cascade') && !isMobile) {

          let scrollItems = container.querySelectorAll('.scroll-item');
  
          let i = 1;
          scrollItems.forEach(scrollItem => {
  
            let delay = 0
  
            if (i != 1) {
  
              //delay = 0.1*i
  
            }
            masterTl.from(scrollItem, {y: '4rem', duration: 0.75, delay: 0,  ease: 'power1.easeinOut'},'<0.075');
  
            const configScrollAnimation = {
              // pin:true,
               trigger: container,
               animation: masterTl,
               //scrub:1,
               start: 'top 90%',
               //end:  'top 55%',
               onEnter: ()=>{
                masterTl.play();
               }
             }
    
            ScrollTrigger.create(configScrollAnimation);
  
            /*
            const tlscrollColScene1 = gsap.timeline({
                scrollTrigger: {
                trigger: container,
                start: "top bottom",
                end: "top 60% ",
              
                scrub: 1
                }
            });
            tlscrollColScene1.from(scrollItem, {y: '10vh', duration: 1, delay: delay,  ease: 'power1.in'});
  
            */
  
            i++;
          })
        }
    


    });


}